import {Api} from './api';

export class InvoiceService {

	getIntroduction() {
		return Api.get(`/iam-system/product-introduction/view`).then(res => res.data);
	}

	getHeaderInfo(referenceNumber) {
		return Api.get(`/iam-entry/invoices/${referenceNumber}/header-info`).then(res => res.data);
	}

	getTaxCertificate(referenceNumber) {
		return Api.get(`https://pit.iamsoftware.com.vn/api/rest/s1/iam-entry/cert-income-tax/${referenceNumber}/pdf`);
	}

}
